import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import type { AgentType } from '../AgentType';

/**
 * Returns the default Calendar agent type when the cal-copilot-default-calendar-agent
 * flight is enabled, or undefined otherwise.
 *
 * Centralizes the flight check so callers don't need to import
 * isFeatureEnabled individually.
 */
export function getDefaultCalendarAgentType(): AgentType | undefined {
    return isGlobalFeatureEnabled('cal-copilot-default-calendar-agent') ? 'TimeAdvisor' : undefined;
}
